export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/worker.5c3490d5.worker.js");
}
